import React, { useState, createContext } from 'react'
import ReactDOM from 'react-dom'
import { IntlProvider } from 'react-intl'
import config from 'app/config'
import { useAuth } from 'hooks'

export const IntlContext = createContext()

// const { language } = navigator

const Index = ({ children, messages }) => {
    const { authUser } = useAuth()

    // const [lang, setLang] = useLocalStorage('lang')
    const l = config.LANGUAGES.includes(authUser?.language)
        ? authUser.language
        : config.DEFAULT_LANGUAGE

    const [locale, setLocale] = useState(l)

    const setLanguage = value => {
        if (!config.LANGUAGES.includes(value)) {
            return false
        }
        Promise.resolve().then(() => {
            ReactDOM.unstable_batchedUpdates(() => {
                setLocale(value)
                // setLang(value)
            })
        })
    }

    return (
        <IntlContext.Provider value={{ locale, setLanguage }}>
            <IntlProvider messages={messages[locale]} locale={locale}>
                {children}
            </IntlProvider>
        </IntlContext.Provider>
    )
}

export default Index
